import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonGroup } from "primereact/buttongroup";
import { NavLink, useSearchParams } from "react-router-dom";

import { PrimeButton } from "../components/prime/button";
import { useSavedStationTransports } from "../stores/saved-station-transports";
import { Station } from "../types/station";
import { TransportIcon } from "./transport-icon";

export function SavedStationTransports({ stations }: { stations: Station[] }) {
  const [searchParams] = useSearchParams();
  const { savedStationTransports, removeSavedStationTransport } =
    useSavedStationTransports();

  return (
    <>
      {savedStationTransports.map((stationTransport, index) => (
        <ButtonGroup key={`saved-station-transport-${index}`} className="flex">
          <NavLink
            to={`/departures?station=${stationTransport.stationId}&type=${stationTransport.transportType}`}
          >
            <PrimeButton
              icon={
                <TransportIcon transportType={stationTransport.transportType} />
              }
              label={
                stations.find((s) => s.id === stationTransport.stationId)?.name
              }
              outlined={
                !(
                  stationTransport.stationId ===
                    Number(searchParams.get("station")) &&
                  stationTransport.transportType === searchParams.get("type")
                )
              }
              size="small"
            />
          </NavLink>
          <PrimeButton
            color="red"
            icon={<FontAwesomeIcon icon={faTrash} />}
            outlined={true}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              removeSavedStationTransport(stationTransport);
            }}
          />
        </ButtonGroup>
      ))}
    </>
  );
}
